<template>
  <div class="aside" style="width: 200px">
    <el-menu
      class="el-menu-vertical-demo"
      background-color="#f5f6fa"
      text-color="rgba(0, 0, 0, 0.65);"
      active-text-color="#0caf60"
      :default-active="routePath"
      router
    >
      <template v-for="item in items">
        <template v-if="item.subs">
          <el-submenu :index="item.index" :key="item.index">
            <template slot="title">
              <i :class="item.icon"></i
              ><span slot="title">{{ item.title }}</span>
            </template>
            <template v-for="subItem in item.subs">
              <el-submenu
                v-if="subItem.subs"
                :index="subItem.index"
                :key="subItem.index"
              >
                <template slot="title">
                  <i :class="subItem.icon" style="color: #fff"></i
                  ><span slot="title">{{ subItem.title }}</span>
                  {{ subItem.title }}
                </template>
                <!--三级菜单-->
                <el-menu-item
                  v-for="(threeItem, i) in subItem.subs"
                  :key="i"
                  :index="threeItem.index"
                >
                  {{ threeItem.title }}
                </el-menu-item>
              </el-submenu>
              <el-menu-item v-else :index="subItem.index" :key="subItem.index">
                {{ subItem.title }}
              </el-menu-item>
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="item.index" :key="item.index">
            <i :class="item.icon"></i><span slot="title">{{ item.title }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>
<script>
export default {
  name: "Aside",
  inject: ["reload"],
  props: {
    isCollapse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      flag: true,
      items: [
        {
          index: "/chat",
          title: "预约问诊",
        },
        {
          index: "/order",
          title: "挂号记录",
        },
        {
          index: "/prescriptions",
          title: "处方记录",
        },
      ],
      items2: [],
      routePath: "",
    };
  },
  methods: {
  },
  mounted() {
    var _this = this;
    this.routePath = this.$route.path;
  },
  computed: {
    onRoutes() {
      return this.$route.path.replace("/", "");
    },
  },
};
</script>
<style scoped>
.el-select {
  width: 152px;
  height: 40px;
  background: #fcfcfc;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.04);
  border-radius: 6px;
  margin-left: 20px;
  /* border: 1px solid #fff; */
}
.el-submenu__title .el-submenu__title i {
  color: #fff !important;
}
.aside /deep/.el-menu-item:hover{
  background: #9fffd052 !important;
}
</style>
